import React from 'react';
import PropTypes from 'prop-types';
import MathContent from '../../../math-content';
import ChoiceChip from '../../../choice-chip';
import styled from 'styled-components';
import { getCharByElementPosition } from '../../../../lib/exercise';

export const TextContainer = styled(MathContent)`
    margin-bottom: 8px;
    line-height: 1.5rem;
    white-space: break-spaces;

    img {
        margin: 0 4px;
        vertical-align: middle;
    }
`;

export const ChoiceChipContainer = styled.div`
    display: flex;
    align-items: flex-start;
    flex-wrap: wrap;

    margin: -2px;
`;

export const ShotContainer = styled.div`
    &:last-of-type {
        padding-bottom: 0px;
    }
`;

export const ShotsList = styled.ol`
    margin-top: 24px;
    margin-right: 32px;
    padding: 0;

    color: ${(props) => props.theme.colors['text-grey-800']};
    font-weight: 600;
    font-size: 16px;
    line-height: 2.25rem;

    list-style-type: upper-alpha;
    list-style-position: inside;
`;

export const ShotsListItem = styled.li`
    white-space: nowrap;
    counter-increment: shot-counter;
`;

export const ShotsDivider = styled.hr`
    margin: 32px 0;
    border: 0;
    border-radius: 0;
    width: 100%;
    height: 1px;

    background: ${(props) => props.theme.colors['surface-grey-200']};
`;

const Shot = ({
    answers = [],
    badgeIndex,
    correctAnswerId,
    handleClick,
    id,
    isValidated,
    selectedAnswerId,
    text,
    validationType,
    ...props
}) => {
    const getChoiceChipType = (isCorrect, isSelected) => {
        if (isValidated) {
            if (isCorrect || isSelected) {
                return 'validated';
            }

            return 'listed';
        }

        if (isSelected) {
            return 'selected';
        }

        return 'listed';
    };

    return (
        <ShotContainer {...props}>
            <TextContainer>{text}</TextContainer>
            <ChoiceChipContainer>
                {answers.map((answer, index) => {
                    const isSelected = answer.id === selectedAnswerId;
                    const isCorrect = answer.id === correctAnswerId;
                    return (
                        <ChoiceChip
                            badgeIndex={isSelected || isCorrect ? getCharByElementPosition(badgeIndex) : null}
                            useIconsForValidation={true}
                            key={index}
                            id={`${answer.id}`}
                            value={answer.text}
                            handleClick={() => {
                                handleClick(id, answer.id);
                            }}
                            type={getChoiceChipType(isCorrect, isSelected)}
                            validationType={isSelected ? validationType : isCorrect ? 'missing' : null}
                            disabled={isValidated}
                        />
                    );
                })}
            </ChoiceChipContainer>
        </ShotContainer>
    );
};
Shot.propTypes = {
    answers: PropTypes.array,
    badgeIndex: PropTypes.number,
    correctAnswerId: PropTypes.string,
    handleClick: PropTypes.func,
    id: PropTypes.string,
    isValidated: PropTypes.bool,
    selectedAnswerId: PropTypes.string,
    text: PropTypes.string,
    validationType: PropTypes.string,
};
export default Shot;
